module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAYklEQVR42mNgQAKXXFz+k4sZqAFGHYBs4K+IJoIYlwP+Z0oOrAMGJARAvibb56MOGHXAsHcA0Q4b0iFAlSJ71AGUOIAqdcaoA+jlAJzZdTQKRh0w6oBRB4w6YFA5gFYY3U4AMVzr/iVHWiYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_pluri_con.png
// module id = /KKF
// module chunks = 0